const ContentType = {
    JSON: 'application/json; charset=UTF-8',
    FORM: 'application/x-www-form-urlencoded; charset=UTF-8'
};

export default ContentType;



// WEBPACK FOOTER //
// src/web/ContentType.js